import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { PortalLeadNode } from '@app/services/api/api.types';
import { Steps } from '@app/components/stepper/stepper.component';
import { PortalTrackingEvents } from '@app/utils/tracking-events';
import { Tracking } from '@app/services/tracking/tracking.service';

@Component({
  selector: 'travel-expert-info',
  templateUrl: './travel-expert-info.component.html',
  styleUrls: ['./travel-expert-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TravelExpertInfoComponent implements OnInit {
  Steps = Steps;

  @Input() portalLead: PortalLeadNode;

  ngOnInit() {
    Tracking.track(PortalTrackingEvents.leadWithAgentOpened);
  }
}
